import { render, staticRenderFns } from "./RouteDev.vue?vue&type=template&id=4d19cb07&scoped=true&"
import script from "./RouteDev.vue?vue&type=script&lang=js&"
export * from "./RouteDev.vue?vue&type=script&lang=js&"
import style0 from "./RouteDev.vue?vue&type=style&index=0&id=4d19cb07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19cb07",
  null
  
)

export default component.exports